import React from 'react'

const TrashIcon = (props) => {
    const theme = localStorage.getItem('theme') || 'light'
    const color = theme === 'light' ? '#DB4263' : '#FFFFFF'

    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.5 10C18.5 10 18.0408 16.7165 17.7745 19.1244C17.6476 20.2745 16.9399 20.9484 15.7805 20.9697C13.5743 21.0095 11.3656 21.0121 9.16028 20.9654C8.04492 20.9425 7.34899 20.2601 7.22468 19.1304C6.95663 16.7012 6.5 10 6.5 10"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M19.5 6.5H5.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M18.5 6.5C17.777 6.5 16.5 6.5 15.8125 5.98806L15.5887 3.72533C15.4506 3.29655 14.9827 3 14.4494 3H10.5506C10.0173 3 9.54945 3.29655 9.41129 3.72533L9.18748 5.98806C8.5 6.5 7.22302 6.5 6.5 6.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default TrashIcon
